import type {
  EntityEvent,
  EntityEventState,
  EntityEventTypeBasicAlert,
} from '@racemap/sdk/schema/entityEvents';
import type { DateTime } from 'luxon';

export const getFilteredAlerts = (
  alerts: Array<EntityEvent>,
  alertEventTypes: Array<EntityEventTypeBasicAlert>,
  dateRange: [DateTime<boolean>, DateTime<boolean>],
  starterDeviceIds: Array<string>,
  stateFilter: Array<EntityEventState>,
) => {
  const alertsFiltered = alerts.filter((alert) => {
    const alertTime = alert.occurredAt.getTime();
    const inDateRange =
      alertTime >= dateRange[0].toMillis() && alertTime <= dateRange[1].toMillis();

    const inEventType = alertEventTypes.includes(alert.eventType as EntityEventTypeBasicAlert);

    const deviceId = alert.entityId;
    const inStarter =
      starterDeviceIds.length === 0 || starterDeviceIds.includes(deviceId.toHexString());

    const inState = stateFilter.includes(alert.state);

    return inDateRange && inEventType && inStarter && inState;
  });

  return alertsFiltered;
};
